import { Component, input } from '@angular/core';

import { PrivaHeaderComponent } from '@priva/components/header';
import { PrivaWellModule } from '@priva/components/well';
import { PrivaLocalizationModule } from '@priva/localization';

@Component({
    selector: 'app-wizard-step',
    templateUrl: './app-wizard-step.component.html',
    styleUrl: './app-wizard-step.component.scss',
    imports: [PrivaHeaderComponent, PrivaWellModule, PrivaLocalizationModule],
})
export class AppWizardStepComponent {
    title = input('');
}
